module.exports = __webpack_public_path__ + "static/img/category1.d5b4cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/category1.jpg
// module id = w1+E
// module chunks = 0